import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ArrowLeft } from 'react-feather';
import logo from '../../../assets/logo.png';

const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${p => p.theme.colors?.background?.default || '#f9fafb'};
  font-family: 'Inter', sans-serif;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: ${p => p.theme.colors?.background?.paper || '#ffffff'};
  border-bottom: 1px solid ${p => p.theme.colors?.border?.main || '#e5e7eb'};
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${p => p.theme.colors?.text?.primary || '#111827'};
  padding: 8px;
  margin-right: 16px;
  border-radius: 8px;
  &:hover {
    background-color: ${p => p.theme.colors?.action?.hover || '#f3f4f6'};
  }
`;

const Logo = styled.img`
  height: 24px;
`;

const Content = styled.div`
  flex: 1;
  padding: 40px 20px;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${p => p.theme.colors?.text?.primary || '#111827'};
  margin-bottom: 32px;
`;

const DocumentContainer = styled.div`
  background-color: ${p => p.theme.colors?.background?.paper || '#ffffff'};
  border: 1px solid ${p => p.theme.colors?.border?.main || '#e5e7eb'};
  border-radius: 12px;
  padding: 32px;
  font-size: 14px;
  line-height: 1.6;
  color: ${p => p.theme.colors?.text?.secondary || '#4b5563'};
`;

const ESignScreen = () => {
  const navigate = useNavigate();

  return (
    <ScreenContainer>
      <Header>
        <BackButton onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
        </BackButton>
        <Logo src={logo} alt="NYBANQ Logo" />
      </Header>
      
      <Content>
        <Title>E-Sign Disclosure and Consent Notice</Title>
        <DocumentContainer>
          <p>
            <em>Please note: The full text of the E-Sign Disclosure and Consent Notice will be provided here from the Word document.</em>
          </p>
          <p>
            This E-Sign Disclosure and Consent Notice ("Notice") applies to all communications, as defined below, for services provided by NYBANQ and our affiliates.
          </p>
        </DocumentContainer>
      </Content>
    </ScreenContainer>
  );
};

export default ESignScreen;
